import { ExtractColorFromUrlsDocument } from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { toggleUpdatingField } from '@/lib/utils/updating-fields';
import { productsMapState } from '@/states/products.state';
import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';

export const useExtractColorFromUrls = (dealId: string) => {
  const [extractColorFromUrlsMutation, { loading, error }] = useMutation(
    ExtractColorFromUrlsDocument
  );
  const setProductsMap = useSetAtom(productsMapState);

  const extractColorFromUrls = async (dealItemsIds: string[]) => {
    const idsSet = new Set(dealItemsIds);
    const applyUpdatingField = (add: boolean) =>
      setProductsMap((prev) =>
        toggleUpdatingField(prev, idsSet, 'options', add)
      );

    applyUpdatingField(true);
    trackEvent('AI_EXTRACT_COLOR_FROM_URLS_STARTED', {
      dealId,
      itemCount: dealItemsIds.length,
    });
    try {
      const result = await extractColorFromUrlsMutation({
        variables: { dealId, dealItemsIds },
      });
      trackEvent('AI_EXTRACT_COLOR_FROM_URLS_COMPLETED', {
        dealId,
        itemCount: dealItemsIds.length,
      });
      return result;
    } catch (err) {
      applyUpdatingField(false);
      throw err;
    }
  };

  return {
    extractColorFromUrls,
    loading,
    error,
  };
};
